// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "jquery"
import "popper.js"
import "datatables.net"
import "datatables.net-bs5"
import "jstree"
import "../stylesheets/application"
import "bootstrap"
import "../src/noukaweb.js"
import "../src/scroll-hint.min.js"
import "../src/loading.js"

global.jQuery = global.$ = globalThis.jQuery = globalThis.$ = require('jquery');
global.ScrollHint = globalThis.ScrollHint = require('../src/scroll-hint.min.js');
document.addEventListener('turbolinks:load', function() {
    $(function() {
        $('[data-bs-toggle="popover"]').popover();
    });

    $(function() {
        var ads = document.querySelectorAll('.adsbygoogle');
        if (ads.length > 0) {
            ads.forEach(function (ad) {
                if (ad.firstChild) {
                    ad.removeChild(ad.firstChild);
                }
                window.adsbygoogle = window.adsbygoogle || [];
                window.adsbygoogle.push({});
            });
        }
    });

    $(window).on('load', function() {
        if ($('#quickSearchWords').length) {
            const textBoxString = $('#quickSearchWords').val();
            if(textBoxString.match(/^[ 　\r\n\t]*$/)) {
                changeStateButton('#quickSearchSubmitButton', false);
            }
        }
        if ($('#productSearchWords').length) {
            const textBoxString = $('#productSearchWords').val();
            if(textBoxString.match(/^[ 　\r\n\t]*$/)) {
                changeStateButton('#productSearchSubmitButton', false);
            }
        }
        $('.table-responsive').addClass('js-scrollable');
        new ScrollHint('.js-scrollable', {
            i18n: {
                scrollable: 'スクロールできます'
            }
        });
    });

    $('#purposeAll').on('click', function() {
        if ($('#purposeCheckboxes :checked').length === $('#purposeCheckboxes :input').length) {
            $('#purposeAll').text('全選択');
            $('#purposeCheckboxes input[type="checkbox"]').prop('checked', false);
        } else {
            $('#purposeAll').text('全解除');
            $('#purposeCheckboxes input[type="checkbox"]').prop('checked', true);
        }
        checkStateQuickSearchForm();
    });

    $('#purposeCheckboxes input[type="checkbox"]').on('click', function() {
        if ($('#purposeCheckboxes :checked').length === $('#purposeCheckboxes :input').length) {
            $('#purposeAll').text('全解除');
        } else {
            $('#purposeAll').text('全選択');
        }
        checkStateQuickSearchForm();
    });

    $('#quickSearchWords').on('input', function() {
        checkStateQuickSearchForm();
    });

    $('#productSearchWords').on('input', function() {
        checkStateProductSearchForm();
    });

    function checkStateQuickSearchForm() {
        const isTextBoxEnabled = checkTextBox($('#quickSearchWords').val(), '#errorQuickSearchWords', '検索するワードを入力してください。');
        const isCheckBoxEnabled = checkCheckBoxes('#purposeCheckboxes', '#errorPurposeCheckboxes', 'どれか一つは必ず選択してください。');
        changeStateButton('#quickSearchSubmitButton', isTextBoxEnabled && isCheckBoxEnabled);
    }

    function checkStateProductSearchForm() {
        const isTextBoxEnabled = checkTextBox($('#productSearchWords').val(), '#errorProductSearchWords', '検索するワードを入力してください。');
        changeStateButton('#productSearchSubmitButton', isTextBoxEnabled);
    }

    function generateErrorDisplayCode(displayErrorText) {
        return '<p class="text-danger">' +
               '  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-exclamation-triangle\" viewBox=\"0 0 16 16\">\n' +
               '    <path d=\"M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z\"/>\n' +
               '    <path d=\"M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z\"/>\n' +
               '  </svg>' +
               displayErrorText +
               '</p>'
    }

    function checkTextBox(checkTextBoxString, errorDivId, displayErrorText) {
        $(errorDivId + ' p').remove();
        let result = true;
        let textBox = $.trim(checkTextBoxString);

        if(textBox.match(/^[ 　\r\n\t]*$/)) {
            $(errorDivId).append(generateErrorDisplayCode(displayErrorText));
            result = false;
        }
        return result;
    }

    function changeStateButton(buttonId, isEnabled) {
        if(isEnabled) {
            $(buttonId).prop('disabled', false);
        } else {
            $(buttonId).prop('disabled', true);
        }
    }

    function checkCheckBoxes(checkBoxesId, errorDivId, displayErrorText) {
        $(errorDivId + ' p').remove();
        let result = true;
        let checkCount = 0;

        $(checkBoxesId + ' input[type="checkbox"]').each(function() {
            if ($(this).prop('checked')) {
                checkCount = checkCount + 1;
            }
        });

        if(checkCount === 0) {
            $(errorDivId).append(generateErrorDisplayCode(displayErrorText));
            result = false;
        }
        return result;
    }
});

Rails.start();
Turbolinks.start();
ActiveStorage.start();
